var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "table offer-info" },
    [
      _c(
        "el-form",
        { ref: "form", attrs: { model: _vm.c_data } },
        [
          _c(
            "el-table",
            {
              ref: "dataTable",
              staticStyle: { "margin-top": "10px" },
              attrs: { data: _vm.c_data, border: "" },
            },
            [
              _vm.canEdit
                ? _c("el-table-column", {
                    attrs: {
                      selectable: (row) =>
                        row.productDescription != "Warehouse",
                      align: "center",
                      type: "selection",
                      width: "55",
                    },
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  label: "Product Description",
                  prop: "productDescription",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  align: "center",
                  prop: "supplierDc",
                  label: "Supplied Dc",
                  width: "200px",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: `[${scope.$index}].supplierDc`,
                              rules: _vm.dcRule,
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  disabled:
                                    !_vm.c_canEdit ||
                                    scope.row.productDescription == "Warehouse",
                                  multiple: "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.changeDcs(scope.$index)
                                  },
                                },
                                model: {
                                  value: scope.row.supplierDc,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "supplierDc", $$v)
                                  },
                                  expression: "scope.row.supplierDc",
                                },
                              },
                              _vm._l(_vm.dcList, function (item, index) {
                                return _c("el-option", {
                                  attrs: {
                                    label: item.dcName,
                                    value: item.tmDcId,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "adpWithoutVat",
                  label: "ADP Without VAT",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: `[${scope.$index}].adpWithoutVat`,
                              rules: [_vm.requireRule, _vm.priceRule],
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: { disabled: !_vm.canEdit },
                              model: {
                                value: scope.row.adpWithoutVat,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "adpWithoutVat", $$v)
                                },
                                expression: "scope.row.adpWithoutVat",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  label: "VAT(RMB/Per case)",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(_vm._s(_vm.getVat(scope.$index)))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  label: "ADP included VAT",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(_vm._s(_vm.getAdpIncludeVat(scope.$index))),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "vatRate",
                  label: "VAT Rate",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: `[${scope.$index}].vatRate`,
                              rules: _vm.requiredRule,
                            },
                          },
                          [
                            _c("ic-select", {
                              attrs: {
                                disabled: !_vm.canEdit,
                                table: "TT_FPA_PCN",
                                field: "VAT_RATE",
                              },
                              model: {
                                value: scope.row.vatRate,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "vatRate", $$v)
                                },
                                expression: "scope.row.vatRate",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "priceEffectiveDateFrom",
                  label: "PriceEffectiveDateFrom",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: `[${scope.$index}].priceEffectiveDateFrom`,
                              rules: _vm.requiredRule,
                            },
                          },
                          [
                            _c("el-date-picker", {
                              attrs: {
                                "picker-options": {
                                  disabledDate: _vm.maxData(
                                    scope.row.priceEffectiveDateTo
                                  ),
                                },
                                disabled: !_vm.canEdit,
                                "value-format": "yyyy-MM-dd",
                                type: "date",
                                placeholder: "Select Date",
                              },
                              model: {
                                value: scope.row.priceEffectiveDateFrom,
                                callback: function ($$v) {
                                  _vm.$set(
                                    scope.row,
                                    "priceEffectiveDateFrom",
                                    $$v
                                  )
                                },
                                expression: "scope.row.priceEffectiveDateFrom",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "priceEffectiveDateTo",
                  label: "PriceEffectiveDateTo",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: `[${scope.$index}].priceEffectiveDateTo`,
                              rules: _vm.requiredRule,
                            },
                          },
                          [
                            _c("el-date-picker", {
                              attrs: {
                                "picker-options": {
                                  disabledDate: _vm.minDate(
                                    scope.row.priceEffectiveDateFrom
                                  ),
                                },
                                disabled: !_vm.canEdit,
                                "value-format": "yyyy-MM-dd",
                                type: "date",
                                placeholder: "Select Date",
                              },
                              model: {
                                value: scope.row.priceEffectiveDateTo,
                                callback: function ($$v) {
                                  _vm.$set(
                                    scope.row,
                                    "priceEffectiveDateTo",
                                    $$v
                                  )
                                },
                                expression: "scope.row.priceEffectiveDateTo",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }